import React from "react";

class BaseInputComponent extends React.Component {
  searchState = {
    searching: false,
    field: null,
  };
  searchConfig = {
    keyUpTime: 1500, // tiempo de espera en lo que el campo de busqueda es ingresado
    getResultsFunctionName: "",
    propsObjectName: "",
  };
  timeOutSearch = null;

  isValidSearchConfig = () => {
    return (
      (this.searchConfig.getResultsFunctionName ||
        this.searchConfig.getResultsFunctionName.trim().length > 0) &&
      (this.searchConfig.propsObjectName ||
        this.searchConfig.propsObjectName.length > 0)
    );
  };

  handleSearchField = (searchField?: string) => {
    if (!this.isValidSearchConfig()) return;

    if (this.timeOutSearch) clearTimeout(this.timeOutSearch);

    this.timeOutSearch = setTimeout(() => {
      searchField = searchField?.trim() || "";
      const field = searchField.length > 0 ? searchField : null;
      const searchData = {
        field,
      };
      // Primera busqueda o finalizando busqueda
      if (
        (field && !this.searchState.searching) ||
        (!field && this.searchState.searching) ||
        (field &&
          this.searchState.searching &&
          field !== this.searchState.field)
      ) {
        searchData["from"] = 0;
        searchData["currentPage"] = 1;
      }
      if (field && !this.searchState.searching)
        this.searchState.searching = true;
      if (!field && this.searchState.searching)
        this.searchState.searching = false;

      this.searchState.field = field;
      this.getResultsForComponent(searchData);
    }, this.searchConfig.keyUpTime);
  };

  handleSearchManual = (callbackFN) => {
    if (this.timeOutSearch) clearTimeout(this.timeOutSearch);
    this.timeOutSearch = setTimeout(() => {
      callbackFN();
    }, this.searchConfig.keyUpTime);
  };

  getResultsForComponent(searchData = null) {
    if (!this.isValidSearchConfig()) return;

    const propsObject = this.props[this.searchConfig.propsObjectName];
    if (!propsObject) return;

    const getResultsFunction =
      this.props[this.searchConfig.getResultsFunctionName];
    if (!getResultsFunction) return;

    if (!searchData) searchData = {};

    if (typeof searchData["currentPage"] === "undefined") {
      const currentPage = propsObject.pagination.currentPage || 1;
      searchData["currentPage"] = currentPage;
    }
    if (typeof searchData["from"] === "undefined") {
      const currentCount = propsObject.elements.length;
      searchData["from"] = currentCount;
    }
    getResultsFunction(searchData);
  }

  onChangeDisabled = () => {};

  onChangeTextInput = (e) => this.setState({ [e.target.name]: e.target.value });

  onChangeCheckField = (e) => {
    const current_value = this.state[e.target.name];
    this.setState({ [e.target.name]: !current_value });
  };

  onChangeInputFile = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangeMultiSelect = (idSelect: string, stateVarName: string) => {
    try {
      // @ts-ignore
      const newValue = $(`#${idSelect}`).val();
      this.setState({ [stateVarName]: newValue });
    } catch (err) {}
  };
}

export default BaseInputComponent;
